<template>
  <div
    class="icon-wrapper"
    :class="{ flash: flash }"
    v-ripple="{ center: true }"
    @click="$emit('click')"
  >
    <!--<div class="icon-wrapper" @click="$emit('click')">-->
    <svg width="3rem" height="3rem" viewBox="0 0 24 24">
      <path :d="this[type]" fill="#cdf4dd" />
    </svg>
  </div>
</template>

<script>
import { mdiCloseThick, mdiLockQuestion } from '@mdi/js'

export default {
  props: ['type', 'flash'],
  data() {
    return {
      close: mdiCloseThick,
      library: mdiLockQuestion,
    }
  },
}
</script>

<style scoped>
.icon-wrapper {
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  color: #cdf4dd;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  -webkit-tap-highlight-color: transparent;
}

.flash {
  animation-name: icon-flash-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes icon-flash-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}

@media (hover: hover) {
  .icon-wrapper:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}
</style>
